import { Link } from "react-router-dom";
import { bigProjectsList } from "./constants";


export const ModernPortfolio = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-stone-900 via-stone-800 to-stone-900">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-stone-900/80 backdrop-blur-md z-50 border-b border-stone-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <span className="text-2xl font-bold text-white">Kyle Kenney</span>
            <div className="flex gap-8">
              <a href="#about" className="text-stone-300 hover:text-white transition-colors">
                About
              </a>
              <a href="#projects" className="text-stone-300 hover:text-white transition-colors">
                Projects
              </a>
              <a href="#contact" className="text-stone-300 hover:text-white transition-colors">
                Contact
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            {/* Left: Content */}
            <div className="space-y-6">
              <h1 className="text-5xl md:text-6xl font-bold text-white">
                Hi! I'm <span className="text-amber-400">Kyle</span>
              </h1>
              <h2 className="text-2xl md:text-3xl text-stone-300">
                Software Engineer in Vienna, VA
              </h2>
              <p className="text-lg text-stone-400">
                I have a passion to build and solve problems through software development.
              </p>
              <div className="flex gap-4 pt-4">
                <a
                  href="#projects"
                  className="px-6 py-3 bg-amber-500 hover:bg-amber-600 text-white rounded-lg font-medium transition-colors"
                >
                  View Projects
                </a>
                <a
                  href="#contact"
                  className="px-6 py-3 border border-stone-600 hover:border-stone-400 text-white rounded-lg font-medium transition-colors"
                >
                  Contact Me
                </a>
              </div>
            </div>

            {/* Right: Image */}
            <div className="flex justify-center md:justify-end">
              <div className="relative">
                <div className="absolute inset-0 bg-amber-500/20 blur-3xl rounded-full"></div>
                <img
                  src="/assets/portfolio/myface.JPG"
                  alt="Kyle Kenney"
                  className="relative w-64 h-64 md:w-80 md:h-80 object-cover rounded-2xl shadow-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 px-4 sm:px-6 lg:px-8 bg-stone-800/50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold text-white mb-8">About Me</h2>
          <div className="space-y-4 text-lg text-stone-300">
            <p>
              I'm a software engineer at AWS, where I work on AWS Payment Cryptography. I love
              turning ideas into interactive web experiences—whether it's a daily puzzle game, a
              Pokemon guessing challenge, or a tool to plan DC bar crawls.
            </p>
            <p>
              When I'm not coding at work, you'll find me experimenting with game development,
              learning new frameworks, or creating web apps that combine my interests in gaming,
              data, and user experience.
            </p>
          </div>
        </div>
      </section>

      {/* Featured Projects */}
      <section id="projects" className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold text-white mb-4">Featured Projects</h2>
          <p className="text-stone-400 mb-12">Check out some of my recent work</p>

          {/* Big Projects - Single centered card */}
          <div className="flex flex-col md:flex-row justify-center gap-8 mb-16">
            {bigProjectsList.map((project, index) => (
              <a
                key={index}
                href={project.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative bg-stone-700 rounded-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 max-w-md w-full"
              >
                <div className="p-12 text-center">
                  <h3 className="text-3xl font-bold text-white mb-4 group-hover:text-amber-400 transition-colors">
                    {project.header}
                  </h3>
                  <p className="text-stone-400 text-lg">{project.description}</p>
                </div>
                <div className="absolute top-4 right-4 w-10 h-10 bg-amber-500/20 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <svg
                    className="w-5 h-5 text-amber-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </div>
              </a>
            ))}
          </div>

          {/* Experiments / Games */}
          <div className="flex justify-center">
            <Link
              to="/experiments"
              className="group relative bg-stone-700 rounded-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 max-w-md w-full"
            >
              <div className="p-12 text-center">
                <h3 className="text-3xl font-bold text-white mb-4 group-hover:text-amber-400 transition-colors">
                  Games & Experiments
                </h3>
                <p className="text-stone-400 text-lg">
                  Interactive games and mini projects I've built for fun
                </p>
              </div>
              <div className="absolute top-4 right-4 w-10 h-10 bg-amber-500/20 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <svg
                  className="w-5 h-5 text-amber-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                  />
                </svg>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 px-4 sm:px-6 lg:px-8 bg-stone-800/50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-white mb-4">Let's Connect</h2>
          <p className="text-xl text-stone-300 mb-8">
            Feel free to reach out via email or connect with me online
          </p>

          {/* Contact Cards */}
          <div className="grid md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            {/* Email */}
            <a
              href="mailto:kenneyky520@gmail.com"
              className="group bg-stone-800 hover:bg-stone-700 rounded-lg p-6 transition-all hover:shadow-lg hover:shadow-amber-500/10 border border-stone-700 hover:border-amber-500/50"
            >
              <div className="flex flex-col items-center gap-3">
                <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center group-hover:bg-amber-500/30 transition-colors">
                  <svg
                    className="w-6 h-6 text-amber-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <div>
                  <div className="font-semibold text-white mb-1">Email</div>
                  <div className="text-sm text-stone-400 group-hover:text-amber-400 transition-colors">
                    Send a message
                  </div>
                </div>
              </div>
            </a>

            {/* GitHub */}
            <a
              href="https://github.com/kenneyky"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-stone-800 hover:bg-stone-700 rounded-lg p-6 transition-all hover:shadow-lg hover:shadow-purple-500/10 border border-stone-700 hover:border-purple-500/50"
            >
              <div className="flex flex-col items-center gap-3">
                <div className="w-12 h-12 bg-purple-500/20 rounded-full flex items-center justify-center group-hover:bg-purple-500/30 transition-colors">
                  <svg className="w-6 h-6 text-purple-400" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                  </svg>
                </div>
                <div>
                  <div className="font-semibold text-white mb-1">GitHub</div>
                  <div className="text-sm text-stone-400 group-hover:text-purple-400 transition-colors">
                    View my code
                  </div>
                </div>
              </div>
            </a>

            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/in/kenneyky/"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-stone-800 hover:bg-stone-700 rounded-lg p-6 transition-all hover:shadow-lg hover:shadow-blue-600/10 border border-stone-700 hover:border-blue-600/50"
            >
              <div className="flex flex-col items-center gap-3">
                <div className="w-12 h-12 bg-blue-600/20 rounded-full flex items-center justify-center group-hover:bg-blue-600/30 transition-colors">
                  <svg className="w-6 h-6 text-blue-500" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                  </svg>
                </div>
                <div>
                  <div className="font-semibold text-white mb-1">LinkedIn</div>
                  <div className="text-sm text-stone-400 group-hover:text-blue-500 transition-colors">
                    Let's connect
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-4 sm:px-6 lg:px-8 border-t border-stone-700">
        <div className="max-w-7xl mx-auto text-center text-stone-400">
          <p>© 2026 Kyle Kenney. Built with React & Tailwind CSS.</p>
        </div>
      </footer>
    </div>
  );
};
